import React, { FunctionComponent } from 'react'
import { useTranslation, Trans } from '../../../../../utils/convergence'

import styles from './styles.module.css'

interface TradeInDisclaimerProps {
  show: boolean
}

export const TradeInDisclaimer: FunctionComponent<TradeInDisclaimerProps> = ({ show }) => {
  useTranslation(['summary'])

  if (!show) {
    return null
  }

  return (
    <div className={styles.tradeInDisclaimer}>
      <Trans
        i18nKey='summary:appleRetail.tradeInDisclaimer'
        components={{
          sup: <sup />,
          u: <u />,
        }}
      />
    </div>
  )
}
